import React from "react";
import OTP from "../../components/Auth/OTPLayer";
import "../../custom.css";

const OTPPage = () => {
  return (
    <>

      {/* OTP */}
      <OTP />

    </>
  );
};

export default OTPPage; 
